/**
 * The page header: the brand, centred, and nothing else. Reads theme/brand.ts
 * so a rebrand never touches this file.
 */

import { BRAND } from '../theme/brand.ts';

export function Header() {
  const logo = BRAND.logo;
  return (
    <header className="site-header">
      {logo ? (
        <img
          className="brand-logo"
          src={logo.src}
          width={logo.width}
          height={logo.height}
          alt={logo.alt}
          // Above the fold on every screen, and preloaded by brand.plugin.ts.
          fetchPriority="high"
          decoding="sync"
        />
      ) : (
        <span className="brand-name">{BRAND.name}</span>
      )}
    </header>
  );
}
